export default __webpack_public_path__ + "static/media/USDL.1a2c0f7a.svg";